/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Tessera Backend API
 * Tessera backend application with Bearer token authentication and multi-tenant support
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  InvalidateOptions,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { BodyType, ErrorType } from '../api-instance';
import { apiInstance } from '../api-instance';
import type {
  PlatformAbortPlatformSkillAttachmentUploadPathParameters,
  PlatformCompletePlatformSkillAttachmentUploadPathParameters,
  PlatformCreateAttachmentPathParameters,
  PlatformDeleteAttachmentPathParameters,
  PlatformDownloadPlatformSkillAttachmentPathParameters,
  PlatformGetAttachmentContentPathParameters,
  PlatformGetAttachmentPathParameters,
  PlatformInitiatePlatformSkillAttachmentUploadPathParameters,
  PlatformListAttachmentsParams,
  PlatformListAttachmentsPathParameters,
  PlatformPutAttachmentContentPathParameters,
  PlatformUpdateAttachmentPathParameters,
  TLHTTPValidationError,
  TLSkillAttachmentDownloadResponse,
  TLSkillAttachmentUploadAbortRequest,
  TLSkillAttachmentUploadAbortResponse,
  TLSkillAttachmentUploadCompleteRequest,
  TLSkillAttachmentUploadInitiateRequest,
  TLSkillAttachmentUploadInitiateResponse,
  TLUserSkillAttachmentContentPutRequest,
  TLUserSkillAttachmentContentResponse,
  TLUserSkillAttachmentCreateRequest,
  TLUserSkillAttachmentListResponse,
  TLUserSkillAttachmentResponse,
  TLUserSkillAttachmentUpdateRequest,
} from './tessera-backend-api.schemas';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary List Attachments
 */
export const platformListAttachments = (
  { slug }: PlatformListAttachmentsPathParameters,
  params?: PlatformListAttachmentsParams,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLUserSkillAttachmentListResponse>(
    { url: `/platform-skills/${slug}/attachments`, method: 'GET', params, signal },
    options,
  );
};

export const getPlatformListAttachmentsQueryKey = (
  { slug }: PlatformListAttachmentsPathParameters,
  params?: PlatformListAttachmentsParams,
) => {
  return ['platform-skills', slug, 'attachments', ...(params ? [params] : [])] as const;
};

export const getPlatformListAttachmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof platformListAttachments>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { slug }: PlatformListAttachmentsPathParameters,
  params?: PlatformListAttachmentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListAttachments>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPlatformListAttachmentsQueryKey({ slug }, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof platformListAttachments>>> = ({ signal }) =>
    platformListAttachments({ slug }, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof platformListAttachments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlatformListAttachmentsQueryResult = NonNullable<Awaited<ReturnType<typeof platformListAttachments>>>;
export type PlatformListAttachmentsQueryError = ErrorType<TLHTTPValidationError>;

export function usePlatformListAttachments<
  TData = Awaited<ReturnType<typeof platformListAttachments>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PlatformListAttachmentsPathParameters,
  params: undefined | PlatformListAttachmentsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListAttachments>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformListAttachments>>,
          TError,
          Awaited<ReturnType<typeof platformListAttachments>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformListAttachments<
  TData = Awaited<ReturnType<typeof platformListAttachments>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PlatformListAttachmentsPathParameters,
  params?: PlatformListAttachmentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListAttachments>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformListAttachments>>,
          TError,
          Awaited<ReturnType<typeof platformListAttachments>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformListAttachments<
  TData = Awaited<ReturnType<typeof platformListAttachments>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PlatformListAttachmentsPathParameters,
  params?: PlatformListAttachmentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListAttachments>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Attachments
 */

export function usePlatformListAttachments<
  TData = Awaited<ReturnType<typeof platformListAttachments>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { slug }: PlatformListAttachmentsPathParameters,
  params?: PlatformListAttachmentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListAttachments>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPlatformListAttachmentsQueryOptions({ slug }, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Attachments
 */
export const prefetchPlatformListAttachmentsQuery = async <
  TData = Awaited<ReturnType<typeof platformListAttachments>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { slug }: PlatformListAttachmentsPathParameters,
  params?: PlatformListAttachmentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformListAttachments>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getPlatformListAttachmentsQueryOptions({ slug }, params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary List Attachments
 */
export const invalidatePlatformListAttachments = async (
  queryClient: QueryClient,
  { slug }: PlatformListAttachmentsPathParameters,
  params?: PlatformListAttachmentsParams,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getPlatformListAttachmentsQueryKey({ slug }, params) }, options);

  return queryClient;
};

/**
 * @summary Create Attachment
 */
export const platformCreateAttachment = (
  { slug }: PlatformCreateAttachmentPathParameters,
  tLUserSkillAttachmentCreateRequest: BodyType<TLUserSkillAttachmentCreateRequest>,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLUserSkillAttachmentResponse>(
    {
      url: `/platform-skills/${slug}/attachments`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: tLUserSkillAttachmentCreateRequest,
      signal,
    },
    options,
  );
};

export const getPlatformCreateAttachmentQueryKey = (
  { slug }: PlatformCreateAttachmentPathParameters,
  tLUserSkillAttachmentCreateRequest?: BodyType<TLUserSkillAttachmentCreateRequest>,
) => {
  return ['POST', 'platform-skills', slug, 'attachments', tLUserSkillAttachmentCreateRequest] as const;
};

export const getPlatformCreateAttachmentQueryOptions = <
  TData = Awaited<ReturnType<typeof platformCreateAttachment>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { slug }: PlatformCreateAttachmentPathParameters,
  tLUserSkillAttachmentCreateRequest: BodyType<TLUserSkillAttachmentCreateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformCreateAttachment>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlatformCreateAttachmentQueryKey({ slug }, tLUserSkillAttachmentCreateRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof platformCreateAttachment>>> = ({ signal }) =>
    platformCreateAttachment({ slug }, tLUserSkillAttachmentCreateRequest, requestOptions, signal);

  return { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof platformCreateAttachment>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlatformCreateAttachmentQueryResult = NonNullable<Awaited<ReturnType<typeof platformCreateAttachment>>>;
export type PlatformCreateAttachmentQueryError = ErrorType<TLHTTPValidationError>;

export function usePlatformCreateAttachment<
  TData = Awaited<ReturnType<typeof platformCreateAttachment>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PlatformCreateAttachmentPathParameters,
  tLUserSkillAttachmentCreateRequest: BodyType<TLUserSkillAttachmentCreateRequest>,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformCreateAttachment>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformCreateAttachment>>,
          TError,
          Awaited<ReturnType<typeof platformCreateAttachment>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformCreateAttachment<
  TData = Awaited<ReturnType<typeof platformCreateAttachment>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PlatformCreateAttachmentPathParameters,
  tLUserSkillAttachmentCreateRequest: BodyType<TLUserSkillAttachmentCreateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformCreateAttachment>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformCreateAttachment>>,
          TError,
          Awaited<ReturnType<typeof platformCreateAttachment>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformCreateAttachment<
  TData = Awaited<ReturnType<typeof platformCreateAttachment>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PlatformCreateAttachmentPathParameters,
  tLUserSkillAttachmentCreateRequest: BodyType<TLUserSkillAttachmentCreateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformCreateAttachment>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Create Attachment
 */

export function usePlatformCreateAttachment<
  TData = Awaited<ReturnType<typeof platformCreateAttachment>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { slug }: PlatformCreateAttachmentPathParameters,
  tLUserSkillAttachmentCreateRequest: BodyType<TLUserSkillAttachmentCreateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformCreateAttachment>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPlatformCreateAttachmentQueryOptions({ slug }, tLUserSkillAttachmentCreateRequest, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Create Attachment
 */
export const prefetchPlatformCreateAttachmentQuery = async <
  TData = Awaited<ReturnType<typeof platformCreateAttachment>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { slug }: PlatformCreateAttachmentPathParameters,
  tLUserSkillAttachmentCreateRequest: BodyType<TLUserSkillAttachmentCreateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformCreateAttachment>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getPlatformCreateAttachmentQueryOptions({ slug }, tLUserSkillAttachmentCreateRequest, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Create Attachment
 */
export const invalidatePlatformCreateAttachment = async (
  queryClient: QueryClient,
  { slug }: PlatformCreateAttachmentPathParameters,
  tLUserSkillAttachmentCreateRequest: BodyType<TLUserSkillAttachmentCreateRequest>,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getPlatformCreateAttachmentQueryKey({ slug }, tLUserSkillAttachmentCreateRequest) },
    options,
  );

  return queryClient;
};

/**
 * @summary Abort Platform Skill Attachment Upload
 */
export const platformAbortPlatformSkillAttachmentUpload = (
  { slug }: PlatformAbortPlatformSkillAttachmentUploadPathParameters,
  tLSkillAttachmentUploadAbortRequest: BodyType<TLSkillAttachmentUploadAbortRequest>,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLSkillAttachmentUploadAbortResponse>(
    {
      url: `/platform-skills/${slug}/attachments/upload/abort`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: tLSkillAttachmentUploadAbortRequest,
      signal,
    },
    options,
  );
};

export const getPlatformAbortPlatformSkillAttachmentUploadQueryKey = (
  { slug }: PlatformAbortPlatformSkillAttachmentUploadPathParameters,
  tLSkillAttachmentUploadAbortRequest?: BodyType<TLSkillAttachmentUploadAbortRequest>,
) => {
  return [
    'POST',
    'platform-skills',
    slug,
    'attachments',
    'upload',
    'abort',
    tLSkillAttachmentUploadAbortRequest,
  ] as const;
};

export const getPlatformAbortPlatformSkillAttachmentUploadQueryOptions = <
  TData = Awaited<ReturnType<typeof platformAbortPlatformSkillAttachmentUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { slug }: PlatformAbortPlatformSkillAttachmentUploadPathParameters,
  tLSkillAttachmentUploadAbortRequest: BodyType<TLSkillAttachmentUploadAbortRequest>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof platformAbortPlatformSkillAttachmentUpload>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPlatformAbortPlatformSkillAttachmentUploadQueryKey({ slug }, tLSkillAttachmentUploadAbortRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof platformAbortPlatformSkillAttachmentUpload>>> = ({ signal }) =>
    platformAbortPlatformSkillAttachmentUpload({ slug }, tLSkillAttachmentUploadAbortRequest, requestOptions, signal);

  return { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof platformAbortPlatformSkillAttachmentUpload>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlatformAbortPlatformSkillAttachmentUploadQueryResult = NonNullable<
  Awaited<ReturnType<typeof platformAbortPlatformSkillAttachmentUpload>>
>;
export type PlatformAbortPlatformSkillAttachmentUploadQueryError = ErrorType<TLHTTPValidationError>;

export function usePlatformAbortPlatformSkillAttachmentUpload<
  TData = Awaited<ReturnType<typeof platformAbortPlatformSkillAttachmentUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PlatformAbortPlatformSkillAttachmentUploadPathParameters,
  tLSkillAttachmentUploadAbortRequest: BodyType<TLSkillAttachmentUploadAbortRequest>,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof platformAbortPlatformSkillAttachmentUpload>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformAbortPlatformSkillAttachmentUpload>>,
          TError,
          Awaited<ReturnType<typeof platformAbortPlatformSkillAttachmentUpload>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformAbortPlatformSkillAttachmentUpload<
  TData = Awaited<ReturnType<typeof platformAbortPlatformSkillAttachmentUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PlatformAbortPlatformSkillAttachmentUploadPathParameters,
  tLSkillAttachmentUploadAbortRequest: BodyType<TLSkillAttachmentUploadAbortRequest>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof platformAbortPlatformSkillAttachmentUpload>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformAbortPlatformSkillAttachmentUpload>>,
          TError,
          Awaited<ReturnType<typeof platformAbortPlatformSkillAttachmentUpload>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformAbortPlatformSkillAttachmentUpload<
  TData = Awaited<ReturnType<typeof platformAbortPlatformSkillAttachmentUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PlatformAbortPlatformSkillAttachmentUploadPathParameters,
  tLSkillAttachmentUploadAbortRequest: BodyType<TLSkillAttachmentUploadAbortRequest>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof platformAbortPlatformSkillAttachmentUpload>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Abort Platform Skill Attachment Upload
 */

export function usePlatformAbortPlatformSkillAttachmentUpload<
  TData = Awaited<ReturnType<typeof platformAbortPlatformSkillAttachmentUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { slug }: PlatformAbortPlatformSkillAttachmentUploadPathParameters,
  tLSkillAttachmentUploadAbortRequest: BodyType<TLSkillAttachmentUploadAbortRequest>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof platformAbortPlatformSkillAttachmentUpload>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPlatformAbortPlatformSkillAttachmentUploadQueryOptions(
    { slug },
    tLSkillAttachmentUploadAbortRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Abort Platform Skill Attachment Upload
 */
export const prefetchPlatformAbortPlatformSkillAttachmentUploadQuery = async <
  TData = Awaited<ReturnType<typeof platformAbortPlatformSkillAttachmentUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { slug }: PlatformAbortPlatformSkillAttachmentUploadPathParameters,
  tLSkillAttachmentUploadAbortRequest: BodyType<TLSkillAttachmentUploadAbortRequest>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof platformAbortPlatformSkillAttachmentUpload>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getPlatformAbortPlatformSkillAttachmentUploadQueryOptions(
    { slug },
    tLSkillAttachmentUploadAbortRequest,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Abort Platform Skill Attachment Upload
 */
export const invalidatePlatformAbortPlatformSkillAttachmentUpload = async (
  queryClient: QueryClient,
  { slug }: PlatformAbortPlatformSkillAttachmentUploadPathParameters,
  tLSkillAttachmentUploadAbortRequest: BodyType<TLSkillAttachmentUploadAbortRequest>,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getPlatformAbortPlatformSkillAttachmentUploadQueryKey({ slug }, tLSkillAttachmentUploadAbortRequest) },
    options,
  );

  return queryClient;
};

/**
 * @summary Complete Platform Skill Attachment Upload
 */
export const platformCompletePlatformSkillAttachmentUpload = (
  { slug }: PlatformCompletePlatformSkillAttachmentUploadPathParameters,
  tLSkillAttachmentUploadCompleteRequest: BodyType<TLSkillAttachmentUploadCompleteRequest>,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLUserSkillAttachmentResponse>(
    {
      url: `/platform-skills/${slug}/attachments/upload/complete`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: tLSkillAttachmentUploadCompleteRequest,
      signal,
    },
    options,
  );
};

export const getPlatformCompletePlatformSkillAttachmentUploadQueryKey = (
  { slug }: PlatformCompletePlatformSkillAttachmentUploadPathParameters,
  tLSkillAttachmentUploadCompleteRequest?: BodyType<TLSkillAttachmentUploadCompleteRequest>,
) => {
  return [
    'POST',
    'platform-skills',
    slug,
    'attachments',
    'upload',
    'complete',
    tLSkillAttachmentUploadCompleteRequest,
  ] as const;
};

export const getPlatformCompletePlatformSkillAttachmentUploadQueryOptions = <
  TData = Awaited<ReturnType<typeof platformCompletePlatformSkillAttachmentUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { slug }: PlatformCompletePlatformSkillAttachmentUploadPathParameters,
  tLSkillAttachmentUploadCompleteRequest: BodyType<TLSkillAttachmentUploadCompleteRequest>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof platformCompletePlatformSkillAttachmentUpload>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPlatformCompletePlatformSkillAttachmentUploadQueryKey({ slug }, tLSkillAttachmentUploadCompleteRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof platformCompletePlatformSkillAttachmentUpload>>> = ({
    signal,
  }) =>
    platformCompletePlatformSkillAttachmentUpload(
      { slug },
      tLSkillAttachmentUploadCompleteRequest,
      requestOptions,
      signal,
    );

  return { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof platformCompletePlatformSkillAttachmentUpload>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlatformCompletePlatformSkillAttachmentUploadQueryResult = NonNullable<
  Awaited<ReturnType<typeof platformCompletePlatformSkillAttachmentUpload>>
>;
export type PlatformCompletePlatformSkillAttachmentUploadQueryError = ErrorType<TLHTTPValidationError>;

export function usePlatformCompletePlatformSkillAttachmentUpload<
  TData = Awaited<ReturnType<typeof platformCompletePlatformSkillAttachmentUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PlatformCompletePlatformSkillAttachmentUploadPathParameters,
  tLSkillAttachmentUploadCompleteRequest: BodyType<TLSkillAttachmentUploadCompleteRequest>,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof platformCompletePlatformSkillAttachmentUpload>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformCompletePlatformSkillAttachmentUpload>>,
          TError,
          Awaited<ReturnType<typeof platformCompletePlatformSkillAttachmentUpload>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformCompletePlatformSkillAttachmentUpload<
  TData = Awaited<ReturnType<typeof platformCompletePlatformSkillAttachmentUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PlatformCompletePlatformSkillAttachmentUploadPathParameters,
  tLSkillAttachmentUploadCompleteRequest: BodyType<TLSkillAttachmentUploadCompleteRequest>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof platformCompletePlatformSkillAttachmentUpload>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformCompletePlatformSkillAttachmentUpload>>,
          TError,
          Awaited<ReturnType<typeof platformCompletePlatformSkillAttachmentUpload>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformCompletePlatformSkillAttachmentUpload<
  TData = Awaited<ReturnType<typeof platformCompletePlatformSkillAttachmentUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PlatformCompletePlatformSkillAttachmentUploadPathParameters,
  tLSkillAttachmentUploadCompleteRequest: BodyType<TLSkillAttachmentUploadCompleteRequest>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof platformCompletePlatformSkillAttachmentUpload>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Complete Platform Skill Attachment Upload
 */

export function usePlatformCompletePlatformSkillAttachmentUpload<
  TData = Awaited<ReturnType<typeof platformCompletePlatformSkillAttachmentUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { slug }: PlatformCompletePlatformSkillAttachmentUploadPathParameters,
  tLSkillAttachmentUploadCompleteRequest: BodyType<TLSkillAttachmentUploadCompleteRequest>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof platformCompletePlatformSkillAttachmentUpload>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPlatformCompletePlatformSkillAttachmentUploadQueryOptions(
    { slug },
    tLSkillAttachmentUploadCompleteRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Complete Platform Skill Attachment Upload
 */
export const prefetchPlatformCompletePlatformSkillAttachmentUploadQuery = async <
  TData = Awaited<ReturnType<typeof platformCompletePlatformSkillAttachmentUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { slug }: PlatformCompletePlatformSkillAttachmentUploadPathParameters,
  tLSkillAttachmentUploadCompleteRequest: BodyType<TLSkillAttachmentUploadCompleteRequest>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof platformCompletePlatformSkillAttachmentUpload>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getPlatformCompletePlatformSkillAttachmentUploadQueryOptions(
    { slug },
    tLSkillAttachmentUploadCompleteRequest,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Complete Platform Skill Attachment Upload
 */
export const invalidatePlatformCompletePlatformSkillAttachmentUpload = async (
  queryClient: QueryClient,
  { slug }: PlatformCompletePlatformSkillAttachmentUploadPathParameters,
  tLSkillAttachmentUploadCompleteRequest: BodyType<TLSkillAttachmentUploadCompleteRequest>,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    {
      queryKey: getPlatformCompletePlatformSkillAttachmentUploadQueryKey(
        { slug },
        tLSkillAttachmentUploadCompleteRequest,
      ),
    },
    options,
  );

  return queryClient;
};

/**
 * @summary Initiate Platform Skill Attachment Upload
 */
export const platformInitiatePlatformSkillAttachmentUpload = (
  { slug }: PlatformInitiatePlatformSkillAttachmentUploadPathParameters,
  tLSkillAttachmentUploadInitiateRequest: BodyType<TLSkillAttachmentUploadInitiateRequest>,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLSkillAttachmentUploadInitiateResponse>(
    {
      url: `/platform-skills/${slug}/attachments/upload/init`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: tLSkillAttachmentUploadInitiateRequest,
      signal,
    },
    options,
  );
};

export const getPlatformInitiatePlatformSkillAttachmentUploadQueryKey = (
  { slug }: PlatformInitiatePlatformSkillAttachmentUploadPathParameters,
  tLSkillAttachmentUploadInitiateRequest?: BodyType<TLSkillAttachmentUploadInitiateRequest>,
) => {
  return [
    'POST',
    'platform-skills',
    slug,
    'attachments',
    'upload',
    'init',
    tLSkillAttachmentUploadInitiateRequest,
  ] as const;
};

export const getPlatformInitiatePlatformSkillAttachmentUploadQueryOptions = <
  TData = Awaited<ReturnType<typeof platformInitiatePlatformSkillAttachmentUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { slug }: PlatformInitiatePlatformSkillAttachmentUploadPathParameters,
  tLSkillAttachmentUploadInitiateRequest: BodyType<TLSkillAttachmentUploadInitiateRequest>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof platformInitiatePlatformSkillAttachmentUpload>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPlatformInitiatePlatformSkillAttachmentUploadQueryKey({ slug }, tLSkillAttachmentUploadInitiateRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof platformInitiatePlatformSkillAttachmentUpload>>> = ({
    signal,
  }) =>
    platformInitiatePlatformSkillAttachmentUpload(
      { slug },
      tLSkillAttachmentUploadInitiateRequest,
      requestOptions,
      signal,
    );

  return { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof platformInitiatePlatformSkillAttachmentUpload>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlatformInitiatePlatformSkillAttachmentUploadQueryResult = NonNullable<
  Awaited<ReturnType<typeof platformInitiatePlatformSkillAttachmentUpload>>
>;
export type PlatformInitiatePlatformSkillAttachmentUploadQueryError = ErrorType<TLHTTPValidationError>;

export function usePlatformInitiatePlatformSkillAttachmentUpload<
  TData = Awaited<ReturnType<typeof platformInitiatePlatformSkillAttachmentUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PlatformInitiatePlatformSkillAttachmentUploadPathParameters,
  tLSkillAttachmentUploadInitiateRequest: BodyType<TLSkillAttachmentUploadInitiateRequest>,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof platformInitiatePlatformSkillAttachmentUpload>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformInitiatePlatformSkillAttachmentUpload>>,
          TError,
          Awaited<ReturnType<typeof platformInitiatePlatformSkillAttachmentUpload>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformInitiatePlatformSkillAttachmentUpload<
  TData = Awaited<ReturnType<typeof platformInitiatePlatformSkillAttachmentUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PlatformInitiatePlatformSkillAttachmentUploadPathParameters,
  tLSkillAttachmentUploadInitiateRequest: BodyType<TLSkillAttachmentUploadInitiateRequest>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof platformInitiatePlatformSkillAttachmentUpload>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformInitiatePlatformSkillAttachmentUpload>>,
          TError,
          Awaited<ReturnType<typeof platformInitiatePlatformSkillAttachmentUpload>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformInitiatePlatformSkillAttachmentUpload<
  TData = Awaited<ReturnType<typeof platformInitiatePlatformSkillAttachmentUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PlatformInitiatePlatformSkillAttachmentUploadPathParameters,
  tLSkillAttachmentUploadInitiateRequest: BodyType<TLSkillAttachmentUploadInitiateRequest>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof platformInitiatePlatformSkillAttachmentUpload>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Initiate Platform Skill Attachment Upload
 */

export function usePlatformInitiatePlatformSkillAttachmentUpload<
  TData = Awaited<ReturnType<typeof platformInitiatePlatformSkillAttachmentUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { slug }: PlatformInitiatePlatformSkillAttachmentUploadPathParameters,
  tLSkillAttachmentUploadInitiateRequest: BodyType<TLSkillAttachmentUploadInitiateRequest>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof platformInitiatePlatformSkillAttachmentUpload>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPlatformInitiatePlatformSkillAttachmentUploadQueryOptions(
    { slug },
    tLSkillAttachmentUploadInitiateRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Initiate Platform Skill Attachment Upload
 */
export const prefetchPlatformInitiatePlatformSkillAttachmentUploadQuery = async <
  TData = Awaited<ReturnType<typeof platformInitiatePlatformSkillAttachmentUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { slug }: PlatformInitiatePlatformSkillAttachmentUploadPathParameters,
  tLSkillAttachmentUploadInitiateRequest: BodyType<TLSkillAttachmentUploadInitiateRequest>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof platformInitiatePlatformSkillAttachmentUpload>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getPlatformInitiatePlatformSkillAttachmentUploadQueryOptions(
    { slug },
    tLSkillAttachmentUploadInitiateRequest,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Initiate Platform Skill Attachment Upload
 */
export const invalidatePlatformInitiatePlatformSkillAttachmentUpload = async (
  queryClient: QueryClient,
  { slug }: PlatformInitiatePlatformSkillAttachmentUploadPathParameters,
  tLSkillAttachmentUploadInitiateRequest: BodyType<TLSkillAttachmentUploadInitiateRequest>,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    {
      queryKey: getPlatformInitiatePlatformSkillAttachmentUploadQueryKey(
        { slug },
        tLSkillAttachmentUploadInitiateRequest,
      ),
    },
    options,
  );

  return queryClient;
};

/**
 * @summary Delete Attachment
 */
export const platformDeleteAttachment = (
  { slug, attachmentId }: PlatformDeleteAttachmentPathParameters,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<void>(
    { url: `/platform-skills/${slug}/attachments/${attachmentId}`, method: 'DELETE', signal },
    options,
  );
};

export const getPlatformDeleteAttachmentQueryKey = ({ slug, attachmentId }: PlatformDeleteAttachmentPathParameters) => {
  return ['DELETE', 'platform-skills', slug, 'attachments', attachmentId] as const;
};

export const getPlatformDeleteAttachmentQueryOptions = <
  TData = Awaited<ReturnType<typeof platformDeleteAttachment>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { slug, attachmentId }: PlatformDeleteAttachmentPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformDeleteAttachment>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPlatformDeleteAttachmentQueryKey({ slug, attachmentId });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof platformDeleteAttachment>>> = ({ signal }) =>
    platformDeleteAttachment({ slug, attachmentId }, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: slug !== null && slug !== undefined && attachmentId !== null && attachmentId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof platformDeleteAttachment>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type PlatformDeleteAttachmentQueryResult = NonNullable<Awaited<ReturnType<typeof platformDeleteAttachment>>>;
export type PlatformDeleteAttachmentQueryError = ErrorType<TLHTTPValidationError>;

export function usePlatformDeleteAttachment<
  TData = Awaited<ReturnType<typeof platformDeleteAttachment>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PlatformDeleteAttachmentPathParameters,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformDeleteAttachment>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformDeleteAttachment>>,
          TError,
          Awaited<ReturnType<typeof platformDeleteAttachment>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformDeleteAttachment<
  TData = Awaited<ReturnType<typeof platformDeleteAttachment>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PlatformDeleteAttachmentPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformDeleteAttachment>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformDeleteAttachment>>,
          TError,
          Awaited<ReturnType<typeof platformDeleteAttachment>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformDeleteAttachment<
  TData = Awaited<ReturnType<typeof platformDeleteAttachment>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PlatformDeleteAttachmentPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformDeleteAttachment>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Delete Attachment
 */

export function usePlatformDeleteAttachment<
  TData = Awaited<ReturnType<typeof platformDeleteAttachment>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { slug, attachmentId }: PlatformDeleteAttachmentPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformDeleteAttachment>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPlatformDeleteAttachmentQueryOptions({ slug, attachmentId }, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Delete Attachment
 */
export const prefetchPlatformDeleteAttachmentQuery = async <
  TData = Awaited<ReturnType<typeof platformDeleteAttachment>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { slug, attachmentId }: PlatformDeleteAttachmentPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformDeleteAttachment>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getPlatformDeleteAttachmentQueryOptions({ slug, attachmentId }, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Delete Attachment
 */
export const invalidatePlatformDeleteAttachment = async (
  queryClient: QueryClient,
  { slug, attachmentId }: PlatformDeleteAttachmentPathParameters,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getPlatformDeleteAttachmentQueryKey({ slug, attachmentId }) },
    options,
  );

  return queryClient;
};

/**
 * @summary Get Attachment
 */
export const platformGetAttachment = (
  { slug, attachmentId }: PlatformGetAttachmentPathParameters,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLUserSkillAttachmentResponse>(
    { url: `/platform-skills/${slug}/attachments/${attachmentId}`, method: 'GET', signal },
    options,
  );
};

export const getPlatformGetAttachmentQueryKey = ({ slug, attachmentId }: PlatformGetAttachmentPathParameters) => {
  return ['platform-skills', slug, 'attachments', attachmentId] as const;
};

export const getPlatformGetAttachmentQueryOptions = <
  TData = Awaited<ReturnType<typeof platformGetAttachment>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { slug, attachmentId }: PlatformGetAttachmentPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformGetAttachment>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPlatformGetAttachmentQueryKey({ slug, attachmentId });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetAttachment>>> = ({ signal }) =>
    platformGetAttachment({ slug, attachmentId }, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: slug !== null && slug !== undefined && attachmentId !== null && attachmentId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof platformGetAttachment>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type PlatformGetAttachmentQueryResult = NonNullable<Awaited<ReturnType<typeof platformGetAttachment>>>;
export type PlatformGetAttachmentQueryError = ErrorType<TLHTTPValidationError>;

export function usePlatformGetAttachment<
  TData = Awaited<ReturnType<typeof platformGetAttachment>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PlatformGetAttachmentPathParameters,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformGetAttachment>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformGetAttachment>>,
          TError,
          Awaited<ReturnType<typeof platformGetAttachment>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformGetAttachment<
  TData = Awaited<ReturnType<typeof platformGetAttachment>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PlatformGetAttachmentPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformGetAttachment>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformGetAttachment>>,
          TError,
          Awaited<ReturnType<typeof platformGetAttachment>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformGetAttachment<
  TData = Awaited<ReturnType<typeof platformGetAttachment>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PlatformGetAttachmentPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformGetAttachment>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Attachment
 */

export function usePlatformGetAttachment<
  TData = Awaited<ReturnType<typeof platformGetAttachment>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { slug, attachmentId }: PlatformGetAttachmentPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformGetAttachment>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPlatformGetAttachmentQueryOptions({ slug, attachmentId }, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Attachment
 */
export const prefetchPlatformGetAttachmentQuery = async <
  TData = Awaited<ReturnType<typeof platformGetAttachment>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { slug, attachmentId }: PlatformGetAttachmentPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformGetAttachment>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getPlatformGetAttachmentQueryOptions({ slug, attachmentId }, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Get Attachment
 */
export const invalidatePlatformGetAttachment = async (
  queryClient: QueryClient,
  { slug, attachmentId }: PlatformGetAttachmentPathParameters,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getPlatformGetAttachmentQueryKey({ slug, attachmentId }) }, options);

  return queryClient;
};

/**
 * @summary Update Attachment
 */
export const platformUpdateAttachment = (
  { slug, attachmentId }: PlatformUpdateAttachmentPathParameters,
  tLUserSkillAttachmentUpdateRequest: BodyType<TLUserSkillAttachmentUpdateRequest>,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLUserSkillAttachmentResponse>(
    {
      url: `/platform-skills/${slug}/attachments/${attachmentId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: tLUserSkillAttachmentUpdateRequest,
      signal,
    },
    options,
  );
};

export const getPlatformUpdateAttachmentQueryKey = (
  { slug, attachmentId }: PlatformUpdateAttachmentPathParameters,
  tLUserSkillAttachmentUpdateRequest?: BodyType<TLUserSkillAttachmentUpdateRequest>,
) => {
  return ['PATCH', 'platform-skills', slug, 'attachments', attachmentId, tLUserSkillAttachmentUpdateRequest] as const;
};

export const getPlatformUpdateAttachmentQueryOptions = <
  TData = Awaited<ReturnType<typeof platformUpdateAttachment>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { slug, attachmentId }: PlatformUpdateAttachmentPathParameters,
  tLUserSkillAttachmentUpdateRequest: BodyType<TLUserSkillAttachmentUpdateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformUpdateAttachment>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPlatformUpdateAttachmentQueryKey({ slug, attachmentId }, tLUserSkillAttachmentUpdateRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof platformUpdateAttachment>>> = ({ signal }) =>
    platformUpdateAttachment({ slug, attachmentId }, tLUserSkillAttachmentUpdateRequest, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: slug !== null && slug !== undefined && attachmentId !== null && attachmentId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof platformUpdateAttachment>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type PlatformUpdateAttachmentQueryResult = NonNullable<Awaited<ReturnType<typeof platformUpdateAttachment>>>;
export type PlatformUpdateAttachmentQueryError = ErrorType<TLHTTPValidationError>;

export function usePlatformUpdateAttachment<
  TData = Awaited<ReturnType<typeof platformUpdateAttachment>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PlatformUpdateAttachmentPathParameters,
  tLUserSkillAttachmentUpdateRequest: BodyType<TLUserSkillAttachmentUpdateRequest>,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformUpdateAttachment>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformUpdateAttachment>>,
          TError,
          Awaited<ReturnType<typeof platformUpdateAttachment>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformUpdateAttachment<
  TData = Awaited<ReturnType<typeof platformUpdateAttachment>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PlatformUpdateAttachmentPathParameters,
  tLUserSkillAttachmentUpdateRequest: BodyType<TLUserSkillAttachmentUpdateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformUpdateAttachment>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformUpdateAttachment>>,
          TError,
          Awaited<ReturnType<typeof platformUpdateAttachment>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformUpdateAttachment<
  TData = Awaited<ReturnType<typeof platformUpdateAttachment>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PlatformUpdateAttachmentPathParameters,
  tLUserSkillAttachmentUpdateRequest: BodyType<TLUserSkillAttachmentUpdateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformUpdateAttachment>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Update Attachment
 */

export function usePlatformUpdateAttachment<
  TData = Awaited<ReturnType<typeof platformUpdateAttachment>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { slug, attachmentId }: PlatformUpdateAttachmentPathParameters,
  tLUserSkillAttachmentUpdateRequest: BodyType<TLUserSkillAttachmentUpdateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformUpdateAttachment>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPlatformUpdateAttachmentQueryOptions(
    { slug, attachmentId },
    tLUserSkillAttachmentUpdateRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Update Attachment
 */
export const prefetchPlatformUpdateAttachmentQuery = async <
  TData = Awaited<ReturnType<typeof platformUpdateAttachment>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { slug, attachmentId }: PlatformUpdateAttachmentPathParameters,
  tLUserSkillAttachmentUpdateRequest: BodyType<TLUserSkillAttachmentUpdateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformUpdateAttachment>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getPlatformUpdateAttachmentQueryOptions(
    { slug, attachmentId },
    tLUserSkillAttachmentUpdateRequest,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Update Attachment
 */
export const invalidatePlatformUpdateAttachment = async (
  queryClient: QueryClient,
  { slug, attachmentId }: PlatformUpdateAttachmentPathParameters,
  tLUserSkillAttachmentUpdateRequest: BodyType<TLUserSkillAttachmentUpdateRequest>,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getPlatformUpdateAttachmentQueryKey({ slug, attachmentId }, tLUserSkillAttachmentUpdateRequest) },
    options,
  );

  return queryClient;
};

/**
 * @summary Get Attachment Content
 */
export const platformGetAttachmentContent = (
  { slug, attachmentId }: PlatformGetAttachmentContentPathParameters,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLUserSkillAttachmentContentResponse>(
    { url: `/platform-skills/${slug}/attachments/${attachmentId}/content`, method: 'GET', signal },
    options,
  );
};

export const getPlatformGetAttachmentContentQueryKey = ({
  slug,
  attachmentId,
}: PlatformGetAttachmentContentPathParameters) => {
  return ['platform-skills', slug, 'attachments', attachmentId, 'content'] as const;
};

export const getPlatformGetAttachmentContentQueryOptions = <
  TData = Awaited<ReturnType<typeof platformGetAttachmentContent>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { slug, attachmentId }: PlatformGetAttachmentContentPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformGetAttachmentContent>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPlatformGetAttachmentContentQueryKey({ slug, attachmentId });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof platformGetAttachmentContent>>> = ({ signal }) =>
    platformGetAttachmentContent({ slug, attachmentId }, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: slug !== null && slug !== undefined && attachmentId !== null && attachmentId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof platformGetAttachmentContent>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type PlatformGetAttachmentContentQueryResult = NonNullable<
  Awaited<ReturnType<typeof platformGetAttachmentContent>>
>;
export type PlatformGetAttachmentContentQueryError = ErrorType<TLHTTPValidationError>;

export function usePlatformGetAttachmentContent<
  TData = Awaited<ReturnType<typeof platformGetAttachmentContent>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PlatformGetAttachmentContentPathParameters,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformGetAttachmentContent>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformGetAttachmentContent>>,
          TError,
          Awaited<ReturnType<typeof platformGetAttachmentContent>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformGetAttachmentContent<
  TData = Awaited<ReturnType<typeof platformGetAttachmentContent>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PlatformGetAttachmentContentPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformGetAttachmentContent>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformGetAttachmentContent>>,
          TError,
          Awaited<ReturnType<typeof platformGetAttachmentContent>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformGetAttachmentContent<
  TData = Awaited<ReturnType<typeof platformGetAttachmentContent>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PlatformGetAttachmentContentPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformGetAttachmentContent>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Attachment Content
 */

export function usePlatformGetAttachmentContent<
  TData = Awaited<ReturnType<typeof platformGetAttachmentContent>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { slug, attachmentId }: PlatformGetAttachmentContentPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformGetAttachmentContent>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPlatformGetAttachmentContentQueryOptions({ slug, attachmentId }, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Attachment Content
 */
export const prefetchPlatformGetAttachmentContentQuery = async <
  TData = Awaited<ReturnType<typeof platformGetAttachmentContent>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { slug, attachmentId }: PlatformGetAttachmentContentPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformGetAttachmentContent>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getPlatformGetAttachmentContentQueryOptions({ slug, attachmentId }, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Get Attachment Content
 */
export const invalidatePlatformGetAttachmentContent = async (
  queryClient: QueryClient,
  { slug, attachmentId }: PlatformGetAttachmentContentPathParameters,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getPlatformGetAttachmentContentQueryKey({ slug, attachmentId }) },
    options,
  );

  return queryClient;
};

/**
 * @summary Put Attachment Content
 */
export const platformPutAttachmentContent = (
  { slug, attachmentId }: PlatformPutAttachmentContentPathParameters,
  tLUserSkillAttachmentContentPutRequest: BodyType<TLUserSkillAttachmentContentPutRequest>,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLUserSkillAttachmentContentResponse>(
    {
      url: `/platform-skills/${slug}/attachments/${attachmentId}/content`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: tLUserSkillAttachmentContentPutRequest,
      signal,
    },
    options,
  );
};

export const getPlatformPutAttachmentContentQueryKey = (
  { slug, attachmentId }: PlatformPutAttachmentContentPathParameters,
  tLUserSkillAttachmentContentPutRequest?: BodyType<TLUserSkillAttachmentContentPutRequest>,
) => {
  return [
    'PUT',
    'platform-skills',
    slug,
    'attachments',
    attachmentId,
    'content',
    tLUserSkillAttachmentContentPutRequest,
  ] as const;
};

export const getPlatformPutAttachmentContentQueryOptions = <
  TData = Awaited<ReturnType<typeof platformPutAttachmentContent>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { slug, attachmentId }: PlatformPutAttachmentContentPathParameters,
  tLUserSkillAttachmentContentPutRequest: BodyType<TLUserSkillAttachmentContentPutRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformPutAttachmentContent>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPlatformPutAttachmentContentQueryKey({ slug, attachmentId }, tLUserSkillAttachmentContentPutRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof platformPutAttachmentContent>>> = ({ signal }) =>
    platformPutAttachmentContent(
      { slug, attachmentId },
      tLUserSkillAttachmentContentPutRequest,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: slug !== null && slug !== undefined && attachmentId !== null && attachmentId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof platformPutAttachmentContent>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type PlatformPutAttachmentContentQueryResult = NonNullable<
  Awaited<ReturnType<typeof platformPutAttachmentContent>>
>;
export type PlatformPutAttachmentContentQueryError = ErrorType<TLHTTPValidationError>;

export function usePlatformPutAttachmentContent<
  TData = Awaited<ReturnType<typeof platformPutAttachmentContent>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PlatformPutAttachmentContentPathParameters,
  tLUserSkillAttachmentContentPutRequest: BodyType<TLUserSkillAttachmentContentPutRequest>,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformPutAttachmentContent>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformPutAttachmentContent>>,
          TError,
          Awaited<ReturnType<typeof platformPutAttachmentContent>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformPutAttachmentContent<
  TData = Awaited<ReturnType<typeof platformPutAttachmentContent>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PlatformPutAttachmentContentPathParameters,
  tLUserSkillAttachmentContentPutRequest: BodyType<TLUserSkillAttachmentContentPutRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformPutAttachmentContent>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformPutAttachmentContent>>,
          TError,
          Awaited<ReturnType<typeof platformPutAttachmentContent>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformPutAttachmentContent<
  TData = Awaited<ReturnType<typeof platformPutAttachmentContent>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PlatformPutAttachmentContentPathParameters,
  tLUserSkillAttachmentContentPutRequest: BodyType<TLUserSkillAttachmentContentPutRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformPutAttachmentContent>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Put Attachment Content
 */

export function usePlatformPutAttachmentContent<
  TData = Awaited<ReturnType<typeof platformPutAttachmentContent>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { slug, attachmentId }: PlatformPutAttachmentContentPathParameters,
  tLUserSkillAttachmentContentPutRequest: BodyType<TLUserSkillAttachmentContentPutRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformPutAttachmentContent>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPlatformPutAttachmentContentQueryOptions(
    { slug, attachmentId },
    tLUserSkillAttachmentContentPutRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Put Attachment Content
 */
export const prefetchPlatformPutAttachmentContentQuery = async <
  TData = Awaited<ReturnType<typeof platformPutAttachmentContent>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { slug, attachmentId }: PlatformPutAttachmentContentPathParameters,
  tLUserSkillAttachmentContentPutRequest: BodyType<TLUserSkillAttachmentContentPutRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof platformPutAttachmentContent>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getPlatformPutAttachmentContentQueryOptions(
    { slug, attachmentId },
    tLUserSkillAttachmentContentPutRequest,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Put Attachment Content
 */
export const invalidatePlatformPutAttachmentContent = async (
  queryClient: QueryClient,
  { slug, attachmentId }: PlatformPutAttachmentContentPathParameters,
  tLUserSkillAttachmentContentPutRequest: BodyType<TLUserSkillAttachmentContentPutRequest>,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    {
      queryKey: getPlatformPutAttachmentContentQueryKey({ slug, attachmentId }, tLUserSkillAttachmentContentPutRequest),
    },
    options,
  );

  return queryClient;
};

/**
 * @summary Download Platform Skill Attachment
 */
export const platformDownloadPlatformSkillAttachment = (
  { slug, attachmentId }: PlatformDownloadPlatformSkillAttachmentPathParameters,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLSkillAttachmentDownloadResponse>(
    { url: `/platform-skills/${slug}/attachments/${attachmentId}/download`, method: 'GET', signal },
    options,
  );
};

export const getPlatformDownloadPlatformSkillAttachmentQueryKey = ({
  slug,
  attachmentId,
}: PlatformDownloadPlatformSkillAttachmentPathParameters) => {
  return ['platform-skills', slug, 'attachments', attachmentId, 'download'] as const;
};

export const getPlatformDownloadPlatformSkillAttachmentQueryOptions = <
  TData = Awaited<ReturnType<typeof platformDownloadPlatformSkillAttachment>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { slug, attachmentId }: PlatformDownloadPlatformSkillAttachmentPathParameters,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof platformDownloadPlatformSkillAttachment>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPlatformDownloadPlatformSkillAttachmentQueryKey({ slug, attachmentId });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof platformDownloadPlatformSkillAttachment>>> = ({ signal }) =>
    platformDownloadPlatformSkillAttachment({ slug, attachmentId }, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: slug !== null && slug !== undefined && attachmentId !== null && attachmentId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof platformDownloadPlatformSkillAttachment>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type PlatformDownloadPlatformSkillAttachmentQueryResult = NonNullable<
  Awaited<ReturnType<typeof platformDownloadPlatformSkillAttachment>>
>;
export type PlatformDownloadPlatformSkillAttachmentQueryError = ErrorType<TLHTTPValidationError>;

export function usePlatformDownloadPlatformSkillAttachment<
  TData = Awaited<ReturnType<typeof platformDownloadPlatformSkillAttachment>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PlatformDownloadPlatformSkillAttachmentPathParameters,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof platformDownloadPlatformSkillAttachment>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformDownloadPlatformSkillAttachment>>,
          TError,
          Awaited<ReturnType<typeof platformDownloadPlatformSkillAttachment>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformDownloadPlatformSkillAttachment<
  TData = Awaited<ReturnType<typeof platformDownloadPlatformSkillAttachment>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PlatformDownloadPlatformSkillAttachmentPathParameters,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof platformDownloadPlatformSkillAttachment>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformDownloadPlatformSkillAttachment>>,
          TError,
          Awaited<ReturnType<typeof platformDownloadPlatformSkillAttachment>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformDownloadPlatformSkillAttachment<
  TData = Awaited<ReturnType<typeof platformDownloadPlatformSkillAttachment>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: PlatformDownloadPlatformSkillAttachmentPathParameters,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof platformDownloadPlatformSkillAttachment>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Download Platform Skill Attachment
 */

export function usePlatformDownloadPlatformSkillAttachment<
  TData = Awaited<ReturnType<typeof platformDownloadPlatformSkillAttachment>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { slug, attachmentId }: PlatformDownloadPlatformSkillAttachmentPathParameters,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof platformDownloadPlatformSkillAttachment>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPlatformDownloadPlatformSkillAttachmentQueryOptions({ slug, attachmentId }, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Download Platform Skill Attachment
 */
export const prefetchPlatformDownloadPlatformSkillAttachmentQuery = async <
  TData = Awaited<ReturnType<typeof platformDownloadPlatformSkillAttachment>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { slug, attachmentId }: PlatformDownloadPlatformSkillAttachmentPathParameters,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof platformDownloadPlatformSkillAttachment>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getPlatformDownloadPlatformSkillAttachmentQueryOptions({ slug, attachmentId }, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Download Platform Skill Attachment
 */
export const invalidatePlatformDownloadPlatformSkillAttachment = async (
  queryClient: QueryClient,
  { slug, attachmentId }: PlatformDownloadPlatformSkillAttachmentPathParameters,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getPlatformDownloadPlatformSkillAttachmentQueryKey({ slug, attachmentId }) },
    options,
  );

  return queryClient;
};
